// This hook calls a function when user clicks outside of the component

import { useRef } from "react";
import useOnClickOutside from "./useOnClickOutside";

export default function useClickedOutside(clicked) {
  const containerRef = useRef(null);
  useOnClickOutside(containerRef, clicked);
  return containerRef;
}
